export default "__VITE_ASSET__Bm4x8xyI__"